"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.getResponseToJSON = exports.getRequestFromJSON = exports.create = exports.createResponseToJSON = exports.createRequestFromJSON = void 0;
const base64url_1 = require("./base64url");
const convert_1 = require("./convert");
const schema_1 = require("./schema");
function createRequestFromJSON(requestJSON) {
    return (0, convert_1.convert)(base64url_1.base64urlToBuffer, schema_1.credentialCreationOptions, requestJSON);
}
exports.createRequestFromJSON = createRequestFromJSON;
function createResponseToJSON(credential) {
    return (0, convert_1.convert)(base64url_1.bufferToBase64url, schema_1.publicKeyCredentialWithAttestation, credential);
}
exports.createResponseToJSON = createResponseToJSON;
async function create(requestJSON) {
    const credential = (await navigator.credentials.create(createRequestFromJSON(requestJSON)));
    return createResponseToJSON(credential);
}
exports.create = create;
function getRequestFromJSON(requestJSON) {
    return (0, convert_1.convert)(base64url_1.base64urlToBuffer, schema_1.credentialRequestOptions, requestJSON);
}
exports.getRequestFromJSON = getRequestFromJSON;
function getResponseToJSON(credential) {
    return (0, convert_1.convert)(base64url_1.bufferToBase64url, schema_1.publicKeyCredentialWithAssertion, credential);
}
exports.getResponseToJSON = getResponseToJSON;
async function get(requestJSON) {
    const credential = (await navigator.credentials.get(getRequestFromJSON(requestJSON)));
    return getResponseToJSON(credential);
}
exports.get = get;
//# sourceMappingURL=api.js.map